/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const GuidePartPage = lazyLoad(
  () => import('./index'),
  module => module.GuidePartPage
);
